export default () => ({
  configs: null,
  loading: false,
  editingConfig: null,
  page: 0,
  sortBy: "property",
  orderBy: "asc",
  search: "",
});
